import { CallbackForm } from '@callback/const';
import { StateUtils } from '@spartacus/core';

export const CALLBACK_FEATURE = 'callback';
export const CALLBACK = '[Callback] Callback';
export const CALLBACK_PROCESS_ID = 'callback';

export interface StateWithCallback {
  [CALLBACK_FEATURE]: CallbackState;
}

export interface CallbackState {
  callback: StateUtils.LoaderState<CallbackForm>;
}
